// @ts-nocheck
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { FileUploadComponent } from '../../dynamic-form/sub-modules/file-upload/file-upload.component';
import { FilesDownloadComponent } from '../files-download/files-download.component';
import { CommentForumTextareaComponent } from './comment-forum-textarea/comment-forum-textarea.component';
import { CommentForumService } from './comment-forum.service';
import { INote } from './note.interface';

@Component({
  selector: 'lbca-comment-forum',
  templateUrl: './comment-forum.component.html',
  styleUrl: './comment-forum.component.scss',
  imports: [
    CommentForumTextareaComponent,
    forwardRef(() => FilesDownloadComponent),
    forwardRef(() => FileUploadComponent),
  ],
})
export class CommentForumComponent implements OnInit {
  private cdref = inject(ChangeDetectorRef);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private commentForumService = inject(CommentForumService);

  historicData: any[] = [];

  isRequired: boolean = false;
  isDisabled: boolean = false;
  loadPage: boolean = false;

  labelValue!: string;
  helperTextValue!: string;
  value!: string;
  err!: any;

  taskId: any;
  context: any;
  config: any;
  valueToSave: any;
  file: any;

  blockAddComents: boolean = false;

  //Data process or task
  data: any;
  editData: any;
  dataAttr: any = {};
  cardInfo: any;
  private dataUpdated = new Subject<void>();
  private dataAttrUpdated = new Subject<void>();
  notes: INote[] = [];

  public fileUploadConfig = null;

  @Input('dataAttr') set dataAttrInput(data) {
    if (data) {
      this.dataAttr = data;
      this.dataAttrUpdated.next();
    }
  }

  @Input('value') set valueData(data) {
    if (data) {
      this.data = data;
      this.dataUpdated.next();
    }
  }

  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set inputValue(val: string) {
    this.value = val;
  }
  @Input() set error(error: any) {
    this.err = error;
  }

  @Input('configuration') set prop(value) {
    if (value) this.config = value;
  }

  @Input() set cardData(data: any) {
    if (data) this.cardInfo = data;
  }

  @Input('contextValue') set contextData(data: any) {
    if (data) this.context = data;
  }

  @Output('focusState') focusEmmit = new EventEmitter();
  @Output('errorState') errorStateEmmiter = new EventEmitter();
  @Output('validStatus') validStateEmmiter = new EventEmitter();
  @Output('changeValue') changeEmmiter = new EventEmitter();

  ngOnInit(): void {
    const params: any = this?.route?.snapshot?.params;

    const regexTask = new RegExp(/^(\/task\/task-form\/)[0-9]+/);
    this.context =
      this.context || this.config.fromContext ? this.cardInfo.context : this.config.entityKey;

    if (regexTask.test(this?.router?.url)) {
      this.taskId = this?.dataAttr?.bpmIdCard || params?.id;
    }

    this.dataUpdated.subscribe(() => {
      this.editData = this.commentForumService.loadContent(this.config.entityKey, this.data);
    });

    const typeLoad = this.commentForumService.typeLoad(this.config);
    const processId: string = this?.dataAttr?.processNumber || params?.processId;

    this.commentForumService
      .loadMessages(typeLoad, processId, this.context, this.taskId)
      .subscribe((response: any[]) => {
        this.notes = response as INote[];

        if (this.notes && this.notes.length > 0) {
          this.historicData = this.commentForumService.filterMessagesByTypeLoad(
            typeLoad,
            this.notes,
            this.config?.entityKey
          );
          this.historicData.sort(
            (a: { createAt: number }, b: { createAt: number }) => a.createAt - b.createAt
          );
        }
      });

    this.cdref.detectChanges();
    this.loadPage = true;
  }

  public textAreaFocus($event) {
    const focus = $event;
    if (!focus) this.setTaskData();
  }

  public emmitFocus($event) {
    this.focusEmmit.emit($event);
  }

  public emmitError($event) {
    this.errorStateEmmiter.emit($event);
  }

  public emmitValid($event) {
    this.validStateEmmiter.emit($event);
  }

  public emmitChange($event) {
    this.valueToSave = $event;
    this.changeEmmiter.emit($event);
  }

  saveUpload(event) {
    this.file = event.context;
    this.setTaskData();
  }

  private setTaskData() {
    if (!this.valueToSave) return;

    if (this.taskId == 'createCase') {
      const params = {
        taskId: this.taskId,
        taskLabel: 'Cadastro Inicial',
        userId: this.valueToSave.userId,
        userFullName: this.valueToSave.userFullName,
        content: this.valueToSave.content,
        context: this.context,
        file: this.file ?? undefined,
      };

      if (!this.editData)
        this.commentForumService.sendNotes(params).subscribe((resp: any) => {
          this.editData = resp;
        });
      else {
        const id = this.editData.id;
        this.commentForumService.upNotes(params, id).subscribe((resp: any) => {
          this.editData = resp;
        });
      }
    } else {
      let params = {};
      if (this.taskId == 'base') {
        params = {
          taskId: this.taskId,
          processId: this.dataAttr.processNumber,
          taskLabel: 'Base',
          userId: this.valueToSave.userId,
          userFullName: this.valueToSave.userFullName,
          content: this.valueToSave.content,
          context: this.context,
          file: this.file ?? undefined,
        };
      } else {
        params = {
          taskId: this.taskId,
          taskLabel: this.cardInfo.label,
          userId: this.valueToSave.userId,
          userFullName: this.valueToSave.userFullName,
          content: this.valueToSave.content,
          bpmItemId: this.cardInfo.bpmItemId,
          context: this.config?.fromObservationInternal ? this.config?.entityKey : this.context,
          file: this.file ?? undefined,
        };
      }

      if (!this.editData)
        this.commentForumService.sendNotes(params).subscribe((resp: any) => {
          this.editData = resp;
        });
      else {
        const id = this.editData.id;
        this.commentForumService.upNotes(params, id).subscribe((resp: any) => {
          this.editData = resp;
        });
      }
    }
  }
}
